import { useState, useEffect, useCallback } from 'react';
import { servicesService } from '../services/api';

export function useServices({ enabled = true } = {}) {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(enabled);
    const [error, setError] = useState(null);

    // Fetch all services on mount
    const fetchServices = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await servicesService.getAll();
            setServices(data);
        } catch (err) {
            setError(err.message);
            console.error('Failed to fetch services:', err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (enabled) {
            fetchServices();
        } else {
            setLoading(false);
        }
    }, [fetchServices, enabled]);

    const addService = useCallback(async (name) => {
        try {
            const newService = await servicesService.create(name);
            setServices(prev => [newService, ...prev]);
            return newService;
        } catch (err) {
            setError(err.message);
            throw err;
        }
    }, []);

    const updateService = useCallback(async (id, name) => {
        try {
            const updated = await servicesService.update(id, name);
            setServices(prev => prev.map(s => s.id === id ? updated : s));
            return updated;
        } catch (err) {
            setError(err.message);
            throw err;
        }
    }, []);

    const deleteService = useCallback(async (id) => {
        try {
            await servicesService.delete(id);
            setServices(prev => prev.filter(s => s.id !== id));
        } catch (err) {
            setError(err.message);
            throw err;
        }
    }, []);

    return {
        services,
        loading,
        error,
        fetchServices,
        addService,
        updateService,
        deleteService
    };
}
